import { render, staticRenderFns } from "./ExtraCharge.vue?vue&type=template&id=3f91a1b1"
import script from "./ExtraCharge.vue?vue&type=script&lang=js"
export * from "./ExtraCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports